import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { nanoid } from "nanoid";

const firebaseConfig = {
  apiKey: "AIzaSyCJQ0R62rDayuMf4fsd729okxICyjJd4MY",
  authDomain: "asta-tournaments.firebaseapp.com",
  projectId: "asta-tournaments",
  storageBucket: "asta-tournaments.appspot.com",
  messagingSenderId: "463076099444",
  appId: "1:463076099444:web:3eee4a8550a5c78d841821",
  measurementId: "G-Y68MGJL95X",
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const db = firebase.firestore();
const provider = new firebase.auth.GoogleAuthProvider();

export const signInWithGoogle = () => {
  auth.signInWithRedirect(provider);
};

export const signOut = () => {
  auth
    .signOut()
    .then(function () {
      // Sign-out successful.
    })
    .catch(function (error) {
      // An error happened.
    });
};

export const addUser = (user, fullName, grade) => {
  db.collection(`users`).doc(user.uid).set({
    fullName: fullName,
    grade: grade,
    createdTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
  });
};

export const updateUser = (user, fullName, grade) => {
  db.collection(`users`).doc(user.uid).set(
    {
      fullName: fullName,
      grade: grade,
    },
    { merge: true }
  );
};

export const createTeam = (user, teamName) => {
  db.runTransaction((transaction) => {
    let docRef = db.collection("data").doc("globals");
    // This code may get re-run multiple times if there are conflicts.
    return transaction.get(docRef).then((doc) => {
      let uuid = nanoid();
      var newid = doc.data().maxid + 1;
      transaction.update(docRef, { maxid: newid });
      db.collection(`teams`)
        .doc(`${newid}`)
        .set({
          teamName: teamName,
          code: uuid,
          teamMembers: [user.uid],
          teamCaptain: user.uid,
        })
        .then(() => {
          db.collection(`timestamps2`).doc(`${newid}`).set(
            {
              timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            },
            { merge: true }
          );
          db.collection(`users`)
            .doc(user.uid)
            .set(
              {
                teamId: `${newid}`,
              },
              { merge: true }
            )
            .then(() => {
              db.collection(`codes`).doc(uuid).set(
                {
                  teamId: newid,
                },
                { merge: true }
              );
            });
        });
    });

    // Add one person to the city population.
    // Note: this could be done without a transaction
    //       by updating the population using FieldValue.increment()
  });
};

export const updateTeam = (teamId, teamName) => {
  db.collection(`teams`).doc(teamId).set(
    {
      teamName: teamName,
    },
    { merge: true }
  );
};

export const joinTeam = (user, fullName, code) => {
  db.collection(`code`)
    .doc(code)
    .collection(`requests`)
    .doc(user.uid)
    .set({
      fullName: fullName,
    })
    .then(() => {
      db.collection(`users`).doc(user.uid).set(
        {
          teamRequest: code,
        },
        { merge: true }
      );
    })
    .catch(() => {
      alert("Invalid team ID!");
    });
};

export const leaveTeam = (user, teamDoc) => {
  let newList = teamDoc.data().teamMembers;

  const index = newList.indexOf(user.uid);
  if (index > -1) {
    newList.splice(index, 1);
  }
  db.collection(`teams`)
    .doc(teamDoc.id)
    .set(
      {
        teamMembers: newList,
      },
      { merge: true }
    )
    .then(() => {
      db.collection(`users`).doc(user.uid).set(
        {
          teamId: firebase.firestore.FieldValue.delete(),
        },
        { merge: true }
      );
    });
};

export const cancelRequest = (user, code) => {
  db.collection(`users`).doc(user.uid).set(
    {
      teamRequest: firebase.firestore.FieldValue.delete(),
    },
    { merge: true }
  );
  db.collection(`code`).doc(code).collection(`requests`).doc(user.uid).delete();
};

export const acceptRequest = (user, code, teamId, userId) => {
  db.collection(`code`)
    .doc(code)
    .collection(`requests`)
    .doc(userId)
    .get()
    .then((doc) => {
      if (!doc.exists) return;
      db.collection(`teams`)
        .doc(teamId)
        .update({
          teamMembers: firebase.firestore.FieldValue.arrayUnion(userId),
        })
        .then(() => {
          db.collection(`users`)
            .doc(userId)
            .collection(`responses`)
            .doc(code)
            .set({
              teamId: teamId,
              success: true,
            });
        });
      db.collection(`code`)
        .doc(code)
        .collection(`requests`)
        .doc(userId)
        .delete();
    });
};

export const denyRequest = (user, code, userId) => {
  db.collection(`users`).doc(userId).collection(`responses`).doc(code).set({
    success: false,
  });
  db.collection(`code`).doc(code).collection(`requests`).doc(userId).delete();
};

export const kickMember = (teamDoc, userId) => {
  let newList = teamDoc.data().teamMembers;

  const index = newList.indexOf(userId);
  if (index > -1) {
    newList.splice(index, 1);
  }
  db.collection(`teams`).doc(teamDoc.id).set(
    {
      teamMembers: newList,
    },
    { merge: true }
  );
};

export const deleteTeam = (user, code, teamId) => {
  db.collection(`code`)
    .doc(code)
    .collection(`requests`)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        denyRequest(user, code, doc.id);
      });
      db.collection(`teams`)
        .doc(teamId)
        .delete()
        .then(() => {
          db.collection(`users`).doc(user.uid).set(
            {
              teamId: firebase.firestore.FieldValue.delete(),
            },
            { merge: true }
          );
        });
    });
};
